// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSection_trigger__7lqat {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 4px 8px;
  padding-right: 0;
}

.ProfileSection_avatar__8U1wy {
  width: 40px !important;
  height: 40px !important;
}

.ProfileSection_title__V6uQs {
  color: #9CA3AF;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
}

.ProfileSection_chevron__8uodC {
  color: #111827;
}

.ProfileSection_updatePasswordBtn__GRjcW{
  background-color: #644EE5;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
}

.ProfileSection_updatePasswordBtn__GRjcW:hover{
  background-color: #5a3fd8;
}`, "",{"version":3,"sources":["webpack://./src/layout/MainLayout/Header/ProfileSection/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".trigger {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 4px 8px;\n  padding-right: 0;\n}\n\n.avatar {\n  width: 40px !important;\n  height: 40px !important;\n}\n\n.title {\n  color: #9CA3AF;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.chevron {\n  color: #111827;\n}\n\n.updatePasswordBtn{\n  background-color: #644EE5;\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.3s ease;\n}\n\n.updatePasswordBtn:hover{\n  background-color: #5a3fd8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `ProfileSection_trigger__7lqat`,
	"avatar": `ProfileSection_avatar__8U1wy`,
	"title": `ProfileSection_title__V6uQs`,
	"chevron": `ProfileSection_chevron__8uodC`,
	"updatePasswordBtn": `ProfileSection_updatePasswordBtn__GRjcW`
};
export default ___CSS_LOADER_EXPORT___;
